// extracted by mini-css-extract-plugin
export default {"seoContent":"seoContent__NjZjO","content":"content__ZDViZ","seoContentBlock":"seoContentBlock__ZDQ1M","seoEntry":"seoEntry__NDA1N"};